<template lang="pug">
el-container.main(style="max-width: 100%;")
  .instrument-detail
    el-row.row(type="flex", justify="center", :gutter="20")
      el-col(:span="24")
        el-card.box-card
          .clearfix(slot="header")
            span 基本信息
          div
            el-form(label-width="160px", size="mini", label-position="left")
              el-form-item(label="缩写代号", style="margin-bottom: 8px") {{ this.instrument.name }}
              el-form-item(label="全名", style="margin-bottom: 8px") {{ this.instrument.fullname }}
              el-form-item(label="Purpose", style="margin-bottom: 8px") {{ this.instrument.purpose }}
              el-form-item(label="简介描述", style="margin-bottom: 8px") {{ this.instrument.description }}
              el-form-item(label="背景", style="margin-bottom: 8px") {{ this.instrument.background }}
              el-form-item(label="扫描技术", style="margin-bottom: 8px") {{ this.instrument.scanning_technique }}
              el-form-item(label="分辨率", style="margin-bottom: 8px") {{ this.instrument.resoluation }}
              el-form-item(label="覆盖周期", style="margin-bottom: 8px") {{ this.instrument.coverage_cycle }}
              el-form-item(label="重量", style="margin-bottom: 8px") {{ this.instrument.mass }}
              el-form-item(label="电源", style="margin-bottom: 8px") {{ this.instrument.power }}
              el-form-item(label="数据传输速率", style="margin-bottom: 8px") {{ this.instrument.data_rate }}
              el-form-item(label="研发机构", style="margin-bottom: 8px") {{ this.instrument.agency }}
              el-form-item(label="Maturity", style="margin-bottom: 8px") {{ this.instrument.maturity }}
              el-form-item(label="使用年限", style="margin-bottom: 8px") {{ this.instrument.utilization_period }}
              el-form-item(label="最后更新时间", style="margin-bottom: 8px") {{ this.instrument.update_time }}
      el-col(:span="24")
        el-card.box-card(style="margin-bottom: 8px;")
          .clearfix(slot="header")
            span 关联信息
          div
            el-form(label-width="90px", size="mini", label-position="left")
              el-form-item(label="仪器分类", style="margin-bottom: 8px") {{ this.instrument.classification ? this.instrument.classification.cn_name : '' }}
              el-form-item(label="已装载卫星", style="margin-bottom: 8px")
                el-tree(
                  :data="this.instrument.equipped",
                  node-key="id",
                  default-expand-all
                )
                  span.custom-tree-node(slot-scope="{ node, data }")
                    span {{ data.name }}
                    span(v-if="'id' in data")
                      router-link(
                        :to="{ name: 'satellite-detail', params: { id: data.id.toString() } }"
                      ) More
    template(v-if="this.instrument.characteristics.length")
      el-row.row(type="flex", justify="center", :gutter="20")
        el-col(:span="24")
          el-card.box-card
            .clearfix(slot="header")
              span 参数信息
            //- el-table(border, stripe, :data="this.instrument.characteristics")
            //-   el-table-column(
            //-     v-for="column in columns",
            //-     :key="column.label",
            //-     :prop="column.prop",
            //-     :label="column.label",
            //-     :formatter="column.formatter"
            //-   )
            el-table(
              :data="this.instrument.characteristics"
              element-loading-text="Loading"
              fit
              stripe
              highlight-current-row
            )
              el-table-column(type="expand")
                template(slot-scope="scope")
                  el-tree(:data="scope.row.treeData" default-expand-all)
              template(v-if="this.instrument.classification.principle ==='雷达' ")
                el-table-column(align="center" label="工作模式")
                  template(slot-scope="scope") {{ scope.row.mode }}
                el-table-column(align="center" label="幅宽（km）")
                  template(slot-scope="scope") {{ scope.row.swath }}
                el-table-column(align="center" label="空间分辨率(米)")
                  template(slot-scope="scope") {{ scope.row.resolution[0] }} x {{ scope.row.resolution[1] }}
                el-table-column(align="center" label="极化类型")
                  template(slot-scope="scope") {{ scope.row.polarisations | polarisationFormat }}
              template(v-else)
                el-table-column(align="center" label="波段编号")
                  template(slot-scope="scope") {{ scope.row.band }}
                el-table-column(align="center" label="光谱范围(微米)")
                  template(slot-scope="scope") {{ scope.row.spectral_range[0] }} - {{ scope.row.spectral_range[1] }}
                el-table-column(align="center" label="空间分辨率(米)")
                  template(slot-scope="scope") {{ scope.row.resolution[0] }} x {{ scope.row.resolution[1] }}
</template>

<script>
// @ is an alias to /src
import { getInstrument, listSatellite } from "@/services";

export default {
  name: "instrument-detail",
  props: ["id"],
  filters: {
    polarisationFormat(val) {
      return val.join(',')
    },
  },
  data() {
    return {
      loading: false,
      instrument: null,
    };
  },
  methods: {
    async fetch() {
      this.loading = true;
      const res1 = await getInstrument({ id: this.id });
      const res2 = await listSatellite({ payloads: this.id });
      this.instrument = res1.data;
      Object.assign(this.instrument, { equipped: res2.data.items })
      this.loading = false;
    },
    formatterSpectralRange(row, column, cellValue) {
      return "";
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>

<style lang="stylus" scoped>
.text {
  font-size: 14px;
}

.row {
  padding-bottom: 10px;
}

.clearfix:before, .clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.instrument-detail {
  width: 100%;
  padding: 20px 20px 0;
}

.data-vendor-tag {
  margin: 2px 2px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

@media only screen and (max-width: 540px) {
  .instrument-detail {
    width: 100%;
    padding: 0;
  }

  .row {
    padding-bottom: 10px;
    flex-wrap: wrap;
  }

  .el-col:nth-child(2) {
    padding-top: 10px;
  }

  .el-card__body {
    overflow: auto;
  }
}
</style>
